/**
 * Where an admin changes the settings that produced a management-invoice row.
 *
 * Every management invoice — issued or forecast — carries the unit it bills
 * (apartment_id / property_id; the projection mirrors them as __unit*). The
 * settings that decide whether and how that unit is billed (collection mode,
 * revenue model, master rent, the offset-invoicing switch — COL-287) live in
 * the property's and the apartment's edit sheet, under "Revenue model" /
 * "Revenue & fees". This resolves a row to that sheet: the apartment's when
 * the row names one, else the property's (rooms assigned to no apartment).
 *
 * The `?edit=revenue` parameter is read by PropertyDetail / ApartmentDetail,
 * which open the sheet on arrival scrolled to that section and drop the
 * parameter again when it closes, so a reload does not reopen it.
 */
export const PAYMENT_CONFIG_EDIT_PARAM = "edit";
export const PAYMENT_CONFIG_EDIT_SECTION = "revenue";

export type PaymentConfigurationTarget = {
  apartment_id?: number | null;
  property_id?: number | null;
  __unitApartmentId?: number | null;
  __unitPropertyId?: number | null;
};

/** Null when the row names no property at all (a legacy portfolio invoice). */
export function paymentConfigurationPath(
  row: PaymentConfigurationTarget
): string | null {
  const propertyId = row.property_id ?? row.__unitPropertyId ?? null;
  if (propertyId == null) return null;
  const apartmentId = row.apartment_id ?? row.__unitApartmentId ?? null;
  const base =
    apartmentId != null
      ? `/admin/properties/${propertyId}/apartments/${apartmentId}`
      : `/admin/properties/${propertyId}`;
  return `${base}?${PAYMENT_CONFIG_EDIT_PARAM}=${PAYMENT_CONFIG_EDIT_SECTION}`;
}
